import { createFileRoute, Outlet } from '@tanstack/react-router';
export const Route = createFileRoute('/ai-automation')({component: AutomationLayout});
function AutomationLayout() { return <Outlet />; }